// extracted by mini-css-extract-plugin
export default {"tiles":"Swagger_tiles__8jkKJ","background-pan":"Swagger_background-pan__0fhua"};